<template>
	<div class="on_sale_table">
		<div class="table" >
			<el-table ref="multipleTable" :height="880" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" :header-cell-style="{color:'#000000'}">
				<el-table-column align="center" prop="sp_name" label="公司推广人" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="name" label="称呼" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="mobile" label="电话" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="proxy_region" label="代理区域" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.proxy_region==''?'/':scope.row.proxy_region}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="proxy_note" label="留言" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{scope.row.proxy_note==''?'/':scope.row.proxy_note}}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="add_time" label="提交时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作"  show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="openDetail(scope.$index, scope.row)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<footer class="d-flex j-sb a-center">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
				</el-pagination>
			</footer>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				coo_id:'',
				tableData:[],
				currentPage: 1, //初始页
				pageSize : 10,
				total_records : 0,
				status:'0',
				keyword:'',
				sp_data:[
					// {text:'全部',value:'0'},
					{text:'发至微信', value:'1'},
					{text:'发至邮箱', value:'2'},
					{text:'线下快递', value:'3'}
				],
				type:2
			}
		},
		methods:{
			admin_get_cooperate_proxy_list	(){
				let params = {
					act:'admin_get_cooperate_proxy_list',
					coo_id:this.coo_id,
					type:2,
					keyword:this.keyword,
					page:this.currentPage,
					size:this.pageSize,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_cooperate_proxy_list(params).then((res)=>{
					this.tableData=[]
					this.total_records=0
					this.tableData = res.data
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.admin_get_cooperate_proxy_list()
			},
			openDetail(index, row){
				this.$router.push({path:'online_detail',query:row})
			}
		},
		created() {
			this.coo_id = this.$route.query.coo_id
			this.admin_get_cooperate_proxy_list()
		}
	}
</script>

<style scoped>
	.on_sale_table{
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.table {
		margin-top: 1.44rem;
		width: 87.5rem;
		height: 100%;
		background: #E6E9ED;
		overflow: hidden;
		padding: 1.25rem;
		border-radius: 0.375rem;
	}
	footer {
		width: 87.5rem;
		height: 3.85rem;
		background: #FFFFFF;
		padding: 0 1.25rem;
		box-sizing: border-box;
		justify-content: flex-end;
		border-radius:0 0 0.375rem 0.375rem;
	}
	.all{
		box-sizing: border-box;
		border:1px solid #205DFF;
		color: #205DFF;
		background-color: #FFFFFF;
	}
	.all-active{
		background-color: #205DFF;
		color: #FFFFFF;
		box-sizing: border-box;
	}
</style>